"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackEndUnMapperService = void 0;
class BackEndUnMapperService {
    unMapModelCode(vehicle) {
        return vehicle.getModelCode() + '_' + vehicle.getType();
    }
}
exports.BackEndUnMapperService = BackEndUnMapperService;
